import { isLeapYear, getYear } from 'date-fns'
import { range } from './range'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime);

export const getDaysFromMonthAndYear = (month?: number|string, year?: number) => {
  if (!month) return 31
  if (+month === 2) {
    if (year) return isLeapYear(new Date(year, 1, 1)) ? 29 : 28
    return 29
  }
  return [4, 6, 9, 11].includes(+month) ? 30 : 31
}

export const getYears = ({
  initialYear = 1960,
  endYear = getYear(new Date()) + 1,
  showOnlyLeapYears = false
}) => {
  const rangeYears = range(initialYear, endYear)
  if (showOnlyLeapYears) {
    return rangeYears.filter(year => isLeapYear(new Date(year, 1, 1)))
  }
  return rangeYears
}

// Function to get the human-readable difference
export function getTimeDifference(propsTime: string | number | Date): string {
  // Get the current time
  const now = dayjs();

  
  // Parse the propsTime to a dayjs object
  const time = dayjs(propsTime);
  
  // Calculate the difference in human-readable format
  const difference = now.to(time);

  return difference;
}